import styled, { keyframes } from 'styled-components'

const pulse = keyframes`
  0%, 100% { opacity: 0.6; }
  50% { opacity: 1; }
`

const SkeletonBar = styled.div`
  height: ${({ $height }) => $height || '14px'};
  width: ${({ $width }) => $width || '100%'};
  border-radius: ${({ $round }) => ($round ? '50%' : '4px')};
  flex-shrink: 0;
  background: #eaecf0;
  animation: ${pulse} 1.4s ease-in-out infinite;
`

export default SkeletonBar
